export default "__VITE_ASSET__CRnDETGQ__"